module.exports = __webpack_public_path__ + "media/images/work_order_img-1678d9c7232c7f0d4703f6ec7b79e3fe.png";